import { createContext } from "react";

const ChequeServiceContext = createContext();

export default ChequeServiceContext;